import { MyAppointmentsChildrenController } from './my_appointments/my_appointments_children_controller';
import { AppointmentsScheduledController } from './scheduled/scheduled';

angular
  .module('capability-ng-appointments')
  .controller('ngMyAppointmentsChildrenController', MyAppointmentsChildrenController)
  .controller('ngAppointmentsScheduledController', AppointmentsScheduledController);

export { MyAppointmentsChildrenController };



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-appointments/src/views/views_module.ts